import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiLoader, TuiDropdown, TuiButton } from '@taiga-ui/core';
import { EmojiComponent as EmojiMartModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { SharedModule } from '@src/app/shared';

import { EmojiListComponent } from './emoji-list';
import { EmojiComponent } from './emoji';
import { EmojiButtonComponent } from './emoji-button';

@NgModule({
  declarations: [EmojiListComponent, EmojiComponent, EmojiButtonComponent],
  imports: [CommonModule, TuiButton, ...TuiDropdown, SharedModule, TuiLoader, EmojiMartModule, PickerComponent],
  exports: [EmojiButtonComponent, EmojiListComponent, EmojiComponent],
})
export class EmojiModule {}
